import React, { FC } from 'react';

const Loader: FC<{ className?: string; width?: string; children?: React.ReactNode }> = ({
  className,
  width,
  children,
}: {
  className?: string;
  width?: string;
  children?: React.ReactNode;
}) => {
  return (
    <div className={'loader' + ' ' + (className ? className : '')}>
      {children ? children : <img src="/images/loader.svg" alt="loader" width={width} />}
    </div>
  );
};
export default Loader;
